export const MaterialConstants = {
  DEFAULT_GSM_UPPER_FACTOR_PERCENT: 5.0,
  DEFAULT_GSM_LOWER_FACTOR_PERCENT: 10.0,
  DEFAULT_THICKNESS_UPPER_FACTOR_PERCENT: 5.0,
  DEFAULT_THICKNESS_LOWER_FACTOR_PERCENT: 5.0,
  DEFAULT_WHITENESS_UPPER_FACTOR_PERCENT: 8.0,
  DEFAULT_WHITENESS_LOWER_FACTOR_PERCENT: 5.0,
};

export const MaterialFixDecimalConstants = {
  GSM_UPPER: 2,
  GSM_LOWER: 2,
  GSM_STANDARD: 2,
  GSM_UPPER_FACTOR_PERCENT: 1,
  GSM_LOWER_FACTOR_PERCENT: 1,
  THICKNESS_STANDARD: 3,
  THICKNESS_UPPER: 3,
  THICKNESS_LOWER: 3,
  THICKNESS_UPPER_FACTOR_PERCENT: 1,
  THICKNESS_LOWER_FACTOR_PERCENT: 1,
  WHITENESS_STANDARD: 2,
  WHITENESS_UPPER: 2,
  WHITENESS_LOWER: 2,
  WHITENESS_UPPER_FACTOR_PERCENT: 1,
  WHITENESS_LOWER_FACTOR_PERCENT: 1,
};

export const DimensionAndWeightConstants = {
  DEFAULT_LENGTH_UPPER_FACTOR_NUMBER: 1.0,
  DEFAULT_LENGTH_LOWER_FACTOR_NUMBER: 1.0,
  DEFAULT_WIDTH_UPPER_FACTOR_NUMBER: 1.0,
  DEFAULT_WIDTH_LOWER_FACTOR_NUMBER: 1.0,
  DEFAULT_HEIGHT_UPPER_FACTOR_NUMBER: 1.5,
  DEFAULT_HEIGHT_LOWER_FACTOR_NUMBER: 1.5,
  DEFAULT_WEIGHT_UPPER_FACTOR_PERCENT: 10.0,
  DEFAULT_WEIGHT_LOWER_FACTOR_PERCENT: 5.0,
};

export const DimensionAndWeightFixDecimalConstants = {
  LENGTH_STANDARD: 1,
  LENGTH_UPPER: 1,
  LENGTH_LOWER: 1,
  LENGTH_UPPER_FACTOR: 1,
  LENGTH_LOWER_FACTOR: 1,
  WIDTH_STANDARD: 1,
  WIDTH_UPPER: 1,
  WIDTH_LOWER: 1,
  WIDTH_UPPER_FACTOR: 1,
  WIDTH_LOWER_FACTOR: 1,
  HEIGHT_STANDARD: 1,
  HEIGHT_UPPER: 1,
  HEIGHT_LOWER: 1,
  HEIGHT_UPPER_FACTOR: 1,
  HEIGHT_LOWER_FACTOR: 1,
  WEIGHT_STANDARD: 3,
  WEIGHT_UPPER: 3,
  WEIGHT_LOWER: 3,
  WEIGHT_UPPER_FACTOR: 1,
  WEIGHT_LOWER_FACTOR: 1,
};
